import "./TwoByTwoLayoutComponent.scss";
import template from "./TwoByTwoLayoutComponent.html";
import {IComponentOptions} from "angular";
import {Observable} from "rxjs";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {BreakpointObserver} from "../../../../../services/breakpoints/BreakpointObserver";
import {Breakpoint} from "../../../../../services/breakpoints/Breakpoint";

export const TwoByTwoLayout = "tfTwoByTwoLayout";

export function twoByTwoLayout(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: TwoByTwoLayoutController
    };
}

export class TwoByTwoLayoutController {

    public readonly widgetDisplay$: Observable<WidgetDisplayMode>;

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.widgetDisplay$ = this.buildWidgetDisplay();
    }

    private buildWidgetDisplay(): Observable<WidgetDisplayMode> {
        return this.breakpointObserver
                   .observe(Breakpoint.WebLandscape)
                   .map((bp) => bp.active)
                   .map((active) => active ? WidgetDisplayMode.WIDE : WidgetDisplayMode.TALL)
                   .publishReplay(1)
                   .refCount();
    }
}
